import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Field, ErrorMessage } from 'formik';
import { Typography } from '@material-tailwind/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import BusquedaSinForm from '../../componentes/BusquedaSinForm';
import { seleccionarTextoInput } from '../../Helpers/utilidades-globales';

export const TabDatosPersonales = ({
    values,
    esVisualizacion,
    setFieldValue,
    handleChange,
    id_iglesia,
    buscarPastorUad,
    desvincular,
    escapeListaP,
    BusquedaPastor,
    cerrarBusquedaPastor,
    finalizarSeleccion,
    buscarEncargadoUad,
    escapeListaE,
    BusquedaEncargado,
    cerrarBusquedaEncargado,
    regiones,
    tiposIglesias
}) => {
    const [distritos, setDistritos] = useState([]);

    useEffect(() => {
        const cargarDistritos = async () => {
            if (values.id_region) {
                try {
                    const { data } = await Axios.get(`/api/tablasgenerales/distritos/${values.id_region}`);
                    setDistritos(data);
                } catch (error) {
                    console.error('Error al cargar distritos', error);
                    setDistritos([]);
                }
            } else {
                setDistritos([]);
            }
        };
        cargarDistritos();
    }, [values.id_region]);

    return (
        <div className="bg-white p-5 rounded-md">
            <div className="flex f-col mt-4">
                <div className="grid grid-cols-3">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Pastor
                    </Typography>
                    {!buscarPastorUad && values.id_pastor_UAD > 0 && <div className='col-span-2 ... flex justify-end'><span className="text-xsmall as-center border-bottom-dotted-gray color-gray">Pastor <span className="bg-blue-400 p-1 text-white rounded-md">Es obrero UAD Id#{values.id_pastor_UAD}</span></span>{!esVisualizacion && <FontAwesomeIcon title='Desvincular al pastor de la iglesia' onClick={() => desvincular({ funcion: setFieldValue, id: 'id_pastor_UAD', nombre: 'nombre_pastor' })} className='cursor-pointer ml-4' icon={faTrashAlt} />}</div>}
                    {!buscarPastorUad && values.id_pastor_UAD === -1 && values.nombre_pastor !== "" && <div className='col-span-2 ... flex justify-end'><span className="text-xsmall as-center border-bottom-dotted-gray color-gray">Pastor <span className="bg-red-400 text-white p-1 rounded-md">Es externo</span></span>{!esVisualizacion && <FontAwesomeIcon title='Desvincular al pastor de la iglesia' onClick={() => desvincular({ funcion: setFieldValue, id: 'id_pastor_UAD', nombre: 'nombre_pastor' })} className='cursor-pointer ml-4' icon={faTrashAlt} />}</div>}
                </div>
                <div className="flex f-row">
                    <Field
                        name="nombre_pastor"
                        type="text"
                        maxLength="200"
                        id="abm-nombre_pastor"
                        data-tip
                        disabled={esVisualizacion}
                        data-for="tooltip_n_pastor"
                        placeholder={'Escriba el nombre del pastor'}
                        autoComplete="off"
                        onKeyDown={(e) => escapeListaP(e)}
                        onInput={() => { BusquedaPastor(setFieldValue) }}
                        onFocus={() => seleccionarTextoInput("abm-nombre_pastor")}
                        className={`input-ui-data ${values.nombre_pastor ? 'input-cvalor' : 'input-vacio'}`}
                    />
                </div>
                <div className="error_formulario"><ErrorMessage name="nombre_pastor" /></div>
                <div className="error_formulario"><ErrorMessage name="id_pastor_UAD" /></div>

                {buscarPastorUad && (
                    <div className="relative z-10 w-fit max-w-full bg-white shadow-md rounded-md mt-1 border border-gray-200 mb-4">
                        <div className="flex items-center gap-2 p-2 border-b border-gray-100 bg-gray-50 rounded-t-md">
                            <span title="Cerrar el listado sin seleccionar" onClick={() => { cerrarBusquedaPastor() }} className="cursor-pointer text-red-500 font-medium text-sm flex items-center hover:bg-red-50 py-1 px-3 rounded-md transition-colors">
                                <FontAwesomeIcon className="mr-2" icon={faWindowClose} /> Cerrar
                            </span>
                            {values.nombre_pastor !== "" && (
                                <span title="Aceptar el nombre ingresado. No es obrero UAD" onClick={() => { cerrarBusquedaPastor() }} className="cursor-pointer bg-blue-500 text-white hover:bg-blue-600 text-sm font-medium py-1 px-3 rounded-md transition-colors">
                                    Aceptar <span className="text-xs font-normal opacity-90">(No es obrero UAD)</span>
                                </span>
                            )}
                        </div>
                        <div className="w-full min-w-[300px] overflow-hidden">
                            <BusquedaSinForm texto={values.nombre_pastor} finalizarSeleccion={finalizarSeleccion} objetoModificacion={{ funcion: setFieldValue, id: 'id_pastor_UAD', nombre: 'nombre_pastor' }} />
                        </div>
                    </div>
                )}
            </div>

            <div className="flex f-col mt-4">
                <div className="grid grid-cols-3">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Encargado
                    </Typography>
                    {!buscarEncargadoUad && values.id_encargado_UAD > 0 && <div className='col-span-2 ... flex justify-end'><span className="text-xsmall as-center border-bottom-dotted-gray color-gray">Encargado <span className="bg-blue-400 p-1 text-white rounded-md"> Es obrero UAD Id#{values.id_encargado_UAD}</span></span>{!esVisualizacion && <FontAwesomeIcon title='Desvinclar al encargado de la iglesia' onClick={() => desvincular({ funcion: setFieldValue, id: 'id_encargado_UAD', nombre: 'nombre_encargado' })} className='cursor-pointer ml-4' icon={faTrashAlt} />}</div>}
                    {!buscarEncargadoUad && values.id_encargado_UAD === -1 && values.nombre_encargado !== "" && <div className='col-span-2 ... flex justify-end'><span className="text-xsmall as-center border-bottom-dotted-gray color-gray">Encargado <span className="bg-red-400 text-white p-1 rounded-md">Es externo</span></span>{!esVisualizacion && <FontAwesomeIcon title='Desvinclar al encargado de la iglesia' onClick={() => desvincular({ funcion: setFieldValue, id: 'id_encargado_UAD', nombre: 'nombre_encargado' })} className='cursor-pointer ml-4' icon={faTrashAlt} />}</div>}
                </div>
                <div className="flex f-row">
                    <Field
                        name="nombre_encargado"
                        type="text"
                        maxLength="200"
                        onKeyDown={(e) => escapeListaE(e)}
                        placeholder={'Escriba el nombre del encargado'}
                        autoComplete="off"
                        disabled={esVisualizacion}
                        id="abm-nombre_encargado"
                        data-tip
                        data-for="tooltip_n_encargado"
                        onInput={() => { BusquedaEncargado(setFieldValue) }}
                        onFocus={() => seleccionarTextoInput("abm-nombre_encargado")}
                        className={`input-ui-data ${values.nombre_encargado ? 'input-cvalor' : 'input-vacio'}`}
                    />
                </div>
                <div className="error_formulario"><ErrorMessage name="nombre_encargado" /></div>
                <div className="error_formulario"><ErrorMessage name="id_encargado_UAD" /></div>
                {buscarEncargadoUad && (
                    <div className="relative z-10 w-fit max-w-full bg-white shadow-md rounded-md mt-1 border border-gray-200 mb-4">
                        <div className="flex items-center gap-2 p-2 border-b border-gray-100 bg-gray-50 rounded-t-md">
                            <span title="Cerrar el listado sin seleccionar" onClick={() => { cerrarBusquedaEncargado() }} className="cursor-pointer text-red-500 font-medium text-sm flex items-center hover:bg-red-50 py-1 px-3 rounded-md transition-colors">
                                <FontAwesomeIcon className="mr-2" icon={faWindowClose} /> Cerrar
                            </span>
                            {values.nombre_encargado !== "" && (
                                <span title="Aceptar el nombre ingresado. No es obrero UAD" onClick={() => { cerrarBusquedaEncargado() }} className="cursor-pointer bg-blue-500 text-white hover:bg-blue-600 text-sm font-medium py-1 px-3 rounded-md transition-colors">
                                    Aceptar {values.nombre_encargado} <span className="text-xs font-normal opacity-90">(No es obrero UAD)</span>
                                </span>
                            )}
                        </div>
                        <div className="w-full min-w-[300px] overflow-hidden">
                            <BusquedaSinForm texto={values.nombre_encargado} finalizarSeleccion={finalizarSeleccion} objetoModificacion={{ funcion: setFieldValue, id: 'id_encargado_UAD', nombre: 'nombre_encargado' }} />
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-row mt-2 items-center gap-2 w-full pt-2">
                <Field id="abm-no_obrero" type="checkbox" disabled={esVisualizacion} name="encargado_uad"
                    className="w-4 h-4 ml-1"
                    checked={!values.encargado_uad}
                    onChange={(e) => setFieldValue('encargado_uad', !e.target.checked)}
                />
                <label htmlFor="abm-no_obrero" className="text-sm font-medium">No es obrero de la UAD</label>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
                <div className="flex f-col el-abm-sel-pos">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Región
                    </Typography>
                    <select onChange={(e) => { handleChange(e); setFieldValue('id_distrito', ''); }} value={values.id_region}
                        name="id_region"
                        disabled={esVisualizacion}
                        className="select-bg-ui w-full" id="abm-curso-id_region">
                        {regiones.map(item =>
                            <option key={`abmcurso-permiso${item.id_region}`} value={item.id_region}>{item.nombre}</option>
                        )}
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_region" /></div>
                </div>

                <div className="flex f-col el-abm-sel-pos">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Tipo de Iglesia
                    </Typography>
                    <select onChange={handleChange} value={values.id_tipo_iglesia}
                        name="id_tipo_iglesia"
                        disabled={esVisualizacion}
                        className="select-bg-ui w-full" id="abm-curso-id_tipo_iglesia">
                        {tiposIglesias.map(item => (
                            <option key={`abmcurso-permiso${item.id_tipo_iglesia}`} value={item.id_tipo_iglesia}>{item.nombre}</option>
                        ))}
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_tipo_iglesia" /></div>
                </div>

                <div className="flex f-col el-abm-sel-pos">
                    <Typography variant="small" color="blue-gray" className="mb-1 font-medium">
                        Distrito
                    </Typography>
                    <select
                        onChange={handleChange}
                        value={values.id_distrito || ''}
                        name="id_distrito"
                        disabled={esVisualizacion || !values.id_region}
                        className="select-bg-ui hide-browser-input-decoration w-full" id="abm-distrito">
                        <option value="" disabled className="text-gray-400">Seleccione un distrito...</option>
                        {distritos && distritos.map(item => (
                            <option key={`abmdistrito${item.id_distrito_region || item.id_distrito}`} value={item.id_distrito}>{item.nombre}</option>
                        ))}
                    </select>
                    <div className="error_formulario"><ErrorMessage name="id_distrito" /></div>
                </div>
            </div>

            <div className="flex flex-col gap-2 mt-6 items-end w-full">
                <div className="flex f-row items-center gap-2">
                    <label htmlFor="abm-es_fundacion" className="text-sm font-medium">Esta iglesia pertenece a una fundación</label>
                    <Field id="abm-es_fundacion" type="checkbox" disabled={esVisualizacion} name="es_fundacion" className="w-4 h-4 ml-1" />
                </div>
                <div className="flex f-row items-center gap-2">
                    <label htmlFor="abm-forzar_igl_principal" className="text-sm font-medium">Forzar ser Iglesia Principal del pastor en ejercicio</label>
                    <Field id="abm-forzar_igl_principal" type="checkbox" disabled={esVisualizacion} name="forzar_igl_principal" className="w-4 h-4 ml-1" />
                </div>
            </div>
        </div>
    );
};
